import React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import NoSsr from '@material-ui/core/NoSsr';
import styles from './styles/styles.module.scss';
const values = require('object.values'); // es shims library

const SsrFallback = props => {
  const slidingTabsClasses = {
    ...styles.tabsRoot,
    ...styles.tabsIndicator,
    ...styles.tabsScroller,
    ...styles.tabsScrollButtons
  };

  const tabClasses = values(props.tabClasses).join(' ');
  const sliderClasses = values(props.slidingTabsClasses).join(' ');

  return (
    <div className={`${styles.ssrFallback} ${slidingTabsClasses} ${styles.flexContainer} ${sliderClasses}`}>
      {props.tabs.map((tab, idx) => {
        return (
          <div key={idx} className={`${styles.ssrTab} ${props.activeIndex === idx && styles.activeSsrTab} ${tabClasses}`}>
            {tab.label}
          </div>
        );
      })}
    </div>
  );
};

const SlidingTabs = props => {
  return (
    <NoSsr fallback={<SsrFallback {...props} />}>
      <Tabs
        classes={{
          ...{
            root: styles.tabsRoot,
            indicator: styles.tabsIndicator,
            scroller: styles.tabsScroller,
            scrollButtons: styles.tabsScrollButtons,
            flexContainer: styles.flexContainer
          },
          ...props.slidingTabsClasses
        }}
        value={props.activeIndex}
        onChange={props.onChange}
        variant={props.variant}
        scrollButtons={props.scrollButtons}
        aria-label="scrollable auto tabs"
      >
        {props.tabs.map((tab, idx) => {
          return (
            <Tab
              classes={{
                ...{
                  root: styles.tabRoot,
                  wrapper: props.activeIndex === idx ? styles.selectedTabWrapper : styles.tabWrapper,
                  textColorInherit: styles.textColorInherit
                },
                ...props.tabClasses
              }}
              disableRipple
              key={tab.label}
              label={tab.label}
            />
          );
        })}
      </Tabs>
    </NoSsr>
  );
};

SlidingTabs.propTypes = {
  onChange: PropTypes.func,
  variant: PropTypes.string,
  activeIndex: PropTypes.number,
  scrollButtons: PropTypes.string,
  tabClasses: PropTypes.objectOf(PropTypes.any),
  slidingTabsClasses: PropTypes.objectOf(PropTypes.any),
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string
    })
  )
};

SlidingTabs.defaultProps = {
  onChange: () => {},
  variant: 'scrollable',
  scrollButtons: 'on',
  activeIndex: 0,
  tabs: [],
  tabClasses: {},
  slidingTabsClasses: {}
};

export default SlidingTabs;
